import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

export const CallToAction = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleGetStarted = () => {
    // Check for stored referral code
    const refCode = localStorage.getItem('referralCode');
    if (refCode) {
      navigate(`/auth?ref=${refCode}`);
    } else {
      navigate("/auth");
    }
  };

  return (
    <div className="bg-gradient-to-br from-[#1A1F2C] to-[#7E69AB] py-24">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
          {t('landing.callToAction.title')}
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-12">
          {t('landing.callToAction.subtitle')}
        </p>
        <Button
          onClick={handleGetStarted}
          className="bg-white text-[#7E69AB] hover:bg-gray-100 px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all"
        >
          {t('landing.callToAction.button')}
        </Button>
      </div>
    </div>
  );
};

